import SocketService from './socketService'

let rId = 1

export const nextRequestId = () => {
  return rId++
}

const scheduleUnsub = (unsub) => {
  window.setTimeout(() => {
    unsub()
  }, 0)
}

export const requestSocket = (
  payload,
  { onError, onSuccess } = {}
) => {
  const requestId = nextRequestId()

  let unsub = () => {}

  if (onError && onSuccess) {
    const unsubscribe = SocketService.on(requestId.toString(), (data) => {
      scheduleUnsub(unsubscribe)

      if (data.result === 1) {
        onSuccess(data)
      } else {
        onError(data)
      }
    })
  }

  SocketService.emit({
    ...payload,
    requestId,
  })

  return {
    unsubscribe: () => scheduleUnsub(unsub),
    requestId,
  }
}

export const requestSocketPromise = (payload) => {
  return new Promise((resolve, reject) => {
    requestSocket(payload, {
      onSuccess: resolve,
      onError: reject,
    })
  })
}

export const requestSocketWithTimeout = (
  payload,
  { onError, onSuccess, timeout = 10000 } = {}
) => {
  let timeoutId = null

  const { unsubscribe, requestId } = requestSocket(payload, {
    onError,
    onSuccess: (data) => {
      if (timeoutId) {
        window.clearTimeout(timeoutId)
      }
      if (onSuccess) {
        onSuccess(data)
      }
    },
  })

  timeoutId = setTimeout(() => {
    unsubscribe()
    if (onError) {
      onError({
        message: 'Request timed out',
        code: 'TIMEOUT',
      })
    }
  }, timeout)

  return {
    requestId,
    unsubscribe: () => {
      if (timeoutId) {
        window.clearTimeout(timeoutId)
      }
      unsubscribe()
    },
    timeoutId,
  }
}

export const requestSocketPromiseWithTimeout = (
  payload,
  { timeout = 10000 } = {}
) => {
  return new Promise((resolve, reject) => {
    requestSocketWithTimeout(payload, {
      onError: reject,
      onSuccess: resolve,
      timeout,
    })
  })
}

export const isTimeoutError = (error) => {
  return 'code' in error && error.code === 'TIMEOUT'
}

export const prepareBody = (body) => {
  if (body === null || body === undefined) {
    return body
  }

  if (typeof body === 'string') {
    return body
  }

  return JSON.stringify(body)
}

export const parseResponseBody = (response) => {
  return JSON.parse(response.data ?? '{}')
}
